<dx-data-grid biz-grid
  [stateStorageKey]="stateStorageKey"
  [showIsLoading]="isLoading"
  [dataSource]='contacts'
  [(selectedRowKeys)]="selectedContacts"
  (onSelectionChanged)="selectionChanged($event)"
  (onInitNewRow)="initNewContactRow($event)"
  (onRowRemoving)="removeContactRow($event)"
  (onRowUpdating)="handleContactSave($event, false)"
  (onRowInserting)="handleContactSave($event, true)"
  summaryDataField="Name">
  >
  <dxo-selection [mode]="selectionMode"></dxo-selection>
  <dxo-editing [mode]="editMode"
    [allowUpdating]="allowUpdating"
    [allowAdding]="allowAdding"
    [allowDeleting]="allowDeleting">
  </dxo-editing>

  <dxi-column dataField="Priority" caption="Priority" dataType="number" sortOrder="asc" width="100" [validationRules]="[{ type: 'required' }]" [allowEditing]="allowEditDefaultColumns"></dxi-column>
  <dxi-column dataField="Name" caption="Name" dataType="string" [validationRules]="[{ type: 'required' }]" [allowEditing]="allowEditDefaultColumns"></dxi-column>
  <dxi-column dataField="EmailAddress" caption="Email" dataType="string" [allowEditing]="allowEditDefaultColumns" [validationRules]="[{ type: 'email' }]" ></dxi-column>
  <dxi-column dataField="MobileNumber" caption="Mobile" dataType="string" width="110" [allowEditing]="allowEditDefaultColumns"></dxi-column>
  <dxi-column dataField="TelephoneNumber" caption="Phone" dataType="string" width="110" [allowEditing]="allowEditDefaultColumns"></dxi-column>
  <dxi-column dataField="CompanyNumber" caption="Company Number" dataType="string" width="110" [allowEditing]="allowEditDefaultColumns"></dxi-column>

  <dxi-column #columnContactTypes
    dataField="ContactTypes" cellTemplate="contactViewTemplate" caption="Types"
    dataType="string" width="150"
    [allowEditing]="allowEditDefaultColumns"
    [calculateSortValue]="calculateSortValue"
    [calculateFilterExpression]="calculateArrayFilterExpression">
    <dxo-header-filter [dataSource]="getContactTypesHeaderFilterData()"></dxo-header-filter>
  </dxi-column>

  <dxi-column dataField="Address" caption="Address" dataType="string" [visible]="false" [allowEditing]="allowEditDefaultColumns"></dxi-column>
  <dxi-column dataField="ZipCode" caption="ZipCode" dataType="string" [visible]="false" [allowEditing]="allowEditDefaultColumns"></dxi-column>
  <dxi-column dataField="City" caption="City" dataType="string" [visible]="false" [allowEditing]="allowEditDefaultColumns"></dxi-column>
  <dxi-column #columnCountries dataField="Country" cellTemplate="countryTemplate" calculateGroupValue="Country.FriendlyName" caption="Country" [visible]="false" [allowEditing]="allowEditDefaultColumns"></dxi-column>
  <dxi-column dataField="CompanyName" caption="Company Name" dataType="string" [visible]="false" [allowEditing]="allowEditDefaultColumns"></dxi-column>
  <dxi-column dataField="Title" caption="Title" dataType="string" [visible]="false" [allowEditing]="allowEditDefaultColumns"></dxi-column>
  <dxi-column dataField="Comment" caption="Comment" dataType="string" [visible]="false" [allowEditing]="allowEditDefaultColumns"></dxi-column>
  <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(contacts, 'CreatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
    <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(contacts, 'UpdatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="false" format="dateTime"></dxi-column>

  @for (column of additionalColumns; track column) {
    <dxi-column
      [dataField]="column.dataField"
      [caption]="column.caption"
      [dataType]="column.dataType || 'string'">
    </dxi-column>
  }
  <!--
  Not working as expected - so the template is created in the component.ts file instead.
  See this thread for further details: https://github.com/DevExpress/devextreme-angular/issues/255 (http://plnkr.co/edit/2TjNT0pV3TQPKzd2sqih?p=preview)
  The browser started 'hanging', so my comment about "it's working" was before the problems began.
  -->
  <!--<div *dxTemplate="let cell of 'contactEditTemplate'">
  <dx-tag-box [dataSource]="contactTypes"
    [value]="cell.value.slice(0)"
    (onValueChanged)="cell.setValue($event.value)"
  displayExpr="Name"></dx-tag-box>
</div>-->

<div *dxTemplate="let cell of 'countryTemplate'">
  <span>{{cell.data.Country?.FriendlyName}}</span>
</div>

<div *dxTemplate="let cell of 'contactViewTemplate'">
  @for (type of cell.data.ContactTypes; track type; let isLast = $last) {
    <span>{{type.Name}}{{isLast ? '' : ', '}}</span>
  }
</div>
</dx-data-grid>
